import { UIConstants } from '@constants';
import { Image } from 'native-base';
import React from 'react';
import Spinner from 'react-native-loading-spinner-overlay';

const Loader: React.FC<any> = props => {
    const { LOADER_GIF } = UIConstants;

    return (
        <Spinner
            color="black"
            visible={props.showLoader}
            size="large"
            textStyle={{ color: 'black' }}
            overlayColor="#111111db"
            customIndicator={<Image source={{ uri: LOADER_GIF }} style={{ width: 100, height: 100 }}></Image>}
        />
    );
};

export default Loader;
